import CreateHousingExpenseForm from "components/housing-expense-request/CreateForm";
import { useNavigate } from "react-router-dom";
const { ArrowLeft } = require("phosphor-react");

const CreateHousingExpense = () => {
  const navigate = useNavigate();

  return (
    <div className="row ms-4">
      <div className="col">
        <div className="row">
          <div className="col-12 col-sm-9 pe-sm-5">
            <div className="main-header pb-0">
              <div className="arrow-and-content d-flex align-items-center">
                <ArrowLeft
                  className="opacity-50 mb-2 me-2 cursor-pointer"
                  size={24}
                  onClick={() => navigate(-1)}
                />
                <h3 className="space">Create Request</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <CreateHousingExpenseForm />
    </div>
  );
};

export default CreateHousingExpense;
